// extracted by mini-css-extract-plugin
module.exports = {"Container":"AppTable_Container__274KY","TableBody":"AppTable_TableBody__3tRqY"};